import axios from "axios";

import { tokenStorage } from "@/utils/tokenStorage";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  headers: {
    "X-My-Secret": "letmein", // <-- always send as JSON
  },
});

// Attach token from storage to every request
api.interceptors.request.use((config) => {
  const token = tokenStorage.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Refresh token on 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Log all errors for debugging
    if (error.response) {
      console.error("API Error Response:", {
        config: {
          method: error.config.method,
          url: error.config.url,
        },
        data: error.response.data,
        status: error.response.status,
        statusText: error.response.statusText,
      });
    } else if (error.request) {
      console.error("API Error Request (no response):", {
        message: error.message,
        request: error.request,
      });
    } else {
      console.error("API Error:", error.message);
    }

    const originalRequest = error.config;
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      try {
        const refreshRes = await axios.post(
          `${import.meta.env.VITE_API_BASE_URL}/refresh`,
          {},
          {
            headers: {
              Authorization: `Bearer ${tokenStorage.getToken()}`,
            },
          },
        );
        const newToken = refreshRes.data.token; // <-- changed from access_token to token
        // Preserve rememberMe preference when refreshing
        const rememberMe = tokenStorage.isRememberMeEnabled();
        tokenStorage.setToken(newToken, rememberMe);
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        // Optionally: logout user, redirect, etc.
        tokenStorage.removeToken();
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  },
);

export default api;
